// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/:org\",\"regex\":\"^/([^/]+)$\",\"paramNames\":[\"org\"],\"hasOptionalPrefix\":false},{\"path\":\"/:org/automations\",\"regex\":\"^/([^/]+)/automations$\",\"paramNames\":[\"org\"],\"hasOptionalPrefix\":false},{\"path\":\"/:org/automations/:automationId/edit\",\"regex\":\"^/([^/]+)/automations/([^/]+)/edit$\",\"paramNames\":[\"org\",\"automationId\"],\"hasOptionalPrefix\":false},{\"path\":\"/:org/automations/:automationId/runs\",\"regex\":\"^/([^/]+)/automations/([^/]+)/runs$\",\"paramNames\":[\"org\",\"automationId\"],\"hasOptionalPrefix\":false},{\"path\":\"/:org/automations/runs\",\"regex\":\"^/([^/]+)/automations/runs$\",\"paramNames\":[\"org\"],\"hasOptionalPrefix\":false},{\"path\":\"/:org/codesmith/machine-definitions\",\"regex\":\"^/([^/]+)/codesmith/machine-definitions$\",\"paramNames\":[\"org\"],\"hasOptionalPrefix\":false},{\"path\":\"/:org/mcp-connections\",\"regex\":\"^/([^/]+)/mcp-connections$\",\"paramNames\":[\"org\"],\"hasOptionalPrefix\":false},{\"path\":\"/:org/sessions/:sessionPath*?\",\"regex\":\"^/([^/]+)/sessions(?:/(.*))?$\",\"paramNames\":[\"org\",\"sessionPath\"],\"hasOptionalPrefix\":false},{\"path\":\"/:org/analytics\",\"regex\":\"^/([^/]+)/analytics$\",\"paramNames\":[\"org\"],\"hasOptionalPrefix\":false},{\"path\":\"/:org/cache\",\"regex\":\"^/([^/]+)/cache$\",\"paramNames\":[\"org\"],\"hasOptionalPrefix\":false},{\"path\":\"/:org/cache/:repository\",\"regex\":\"^/([^/]+)/cache/([^/]+)$\",\"paramNames\":[\"org\",\"repository\"],\"hasOptionalPrefix\":false},{\"path\":\"/:org/codesmith/:repo/pr/:prNumber\",\"regex\":\"^/([^/]+)/codesmith/([^/]+)/pr/([^/]+)$\",\"paramNames\":[\"org\",\"repo\",\"prNumber\"],\"hasOptionalPrefix\":false},{\"path\":\"/:org/docker-analytics\",\"regex\":\"^/([^/]+)/docker-analytics$\",\"paramNames\":[\"org\"],\"hasOptionalPrefix\":false},{\"path\":\"/:org/floor\",\"regex\":\"^/([^/]+)/floor$\",\"paramNames\":[\"org\"],\"hasOptionalPrefix\":false},{\"path\":\"/:org/github-actions-analytics\",\"regex\":\"^/([^/]+)/github-actions-analytics$\",\"paramNames\":[\"org\"],\"hasOptionalPrefix\":false},{\"path\":\"/:org/logs\",\"regex\":\"^/([^/]+)/logs$\",\"paramNames\":[\"org\"],\"hasOptionalPrefix\":false},{\"path\":\"/:org/machine-definitions\",\"regex\":\"^/([^/]+)/machine-definitions$\",\"paramNames\":[\"org\"],\"hasOptionalPrefix\":false},{\"path\":\"/:org/monitors\",\"regex\":\"^/([^/]+)/monitors$\",\"paramNames\":[\"org\"],\"hasOptionalPrefix\":false},{\"path\":\"/:org/monitors/:monitorId\",\"regex\":\"^/([^/]+)/monitors/([^/]+)$\",\"paramNames\":[\"org\",\"monitorId\"],\"hasOptionalPrefix\":false},{\"path\":\"/:org/network-monitoring\",\"regex\":\"^/([^/]+)/network-monitoring$\",\"paramNames\":[\"org\"],\"hasOptionalPrefix\":false},{\"path\":\"/:org/rightsize\",\"regex\":\"^/([^/]+)/rightsize$\",\"paramNames\":[\"org\"],\"hasOptionalPrefix\":false},{\"path\":\"/:org/runs\",\"regex\":\"^/([^/]+)/runs$\",\"paramNames\":[\"org\"],\"hasOptionalPrefix\":false},{\"path\":\"/:org/runs/:runId\",\"regex\":\"^/([^/]+)/runs/([^/]+)$\",\"paramNames\":[\"org\",\"runId\"],\"hasOptionalPrefix\":false},{\"path\":\"/:org/runs/:runId/jobs/:jobId\",\"regex\":\"^/([^/]+)/runs/([^/]+)/jobs/([^/]+)$\",\"paramNames\":[\"org\",\"runId\",\"jobId\"],\"hasOptionalPrefix\":false},{\"path\":\"/:org/runs/jobs\",\"regex\":\"^/([^/]+)/runs/jobs$\",\"paramNames\":[\"org\"],\"hasOptionalPrefix\":false},{\"path\":\"/:org/runs/workflows\",\"regex\":\"^/([^/]+)/runs/workflows$\",\"paramNames\":[\"org\"],\"hasOptionalPrefix\":false},{\"path\":\"/:org/settings\",\"regex\":\"^/([^/]+)/settings$\",\"paramNames\":[\"org\"],\"hasOptionalPrefix\":false},{\"path\":\"/:org/settings/appearance\",\"regex\":\"^/([^/]+)/settings/appearance$\",\"paramNames\":[\"org\"],\"hasOptionalPrefix\":false},{\"path\":\"/:org/settings/codesmith\",\"regex\":\"^/([^/]+)/settings/codesmith$\",\"paramNames\":[\"org\"],\"hasOptionalPrefix\":false},{\"path\":\"/:org/settings/codesmith/dreaming\",\"regex\":\"^/([^/]+)/settings/codesmith/dreaming$\",\"paramNames\":[\"org\"],\"hasOptionalPrefix\":false},{\"path\":\"/:org/settings/codesmith/environment\",\"regex\":\"^/([^/]+)/settings/codesmith/environment$\",\"paramNames\":[\"org\"],\"hasOptionalPrefix\":false},{\"path\":\"/:org/settings/codesmith/mcp\",\"regex\":\"^/([^/]+)/settings/codesmith/mcp$\",\"paramNames\":[\"org\"],\"hasOptionalPrefix\":false},{\"path\":\"/:org/settings/codesmith/memory\",\"regex\":\"^/([^/]+)/settings/codesmith/memory$\",\"paramNames\":[\"org\"],\"hasOptionalPrefix\":false},{\"path\":\"/:org/settings/codesmith/review\",\"regex\":\"^/([^/]+)/settings/codesmith/review$\",\"paramNames\":[\"org\"],\"hasOptionalPrefix\":false},{\"path\":\"/:org/settings/codesmith/skills\",\"regex\":\"^/([^/]+)/settings/codesmith/skills$\",\"paramNames\":[\"org\"],\"hasOptionalPrefix\":false},{\"path\":\"/:org/settings/features\",\"regex\":\"^/([^/]+)/settings/features$\",\"paramNames\":[\"org\"],\"hasOptionalPrefix\":false},{\"path\":\"/:org/settings/integrations\",\"regex\":\"^/([^/]+)/settings/integrations$\",\"paramNames\":[\"org\"],\"hasOptionalPrefix\":false},{\"path\":\"/:org/settings/team\",\"regex\":\"^/([^/]+)/settings/team$\",\"paramNames\":[\"org\"],\"hasOptionalPrefix\":false},{\"path\":\"/:org/stickydisks\",\"regex\":\"^/([^/]+)/stickydisks$\",\"paramNames\":[\"org\"],\"hasOptionalPrefix\":false},{\"path\":\"/:org/stickydisks/:repository\",\"regex\":\"^/([^/]+)/stickydisks/([^/]+)$\",\"paramNames\":[\"org\",\"repository\"],\"hasOptionalPrefix\":false},{\"path\":\"/:org/support\",\"regex\":\"^/([^/]+)/support$\",\"paramNames\":[\"org\"],\"hasOptionalPrefix\":false},{\"path\":\"/:org/testboxes\",\"regex\":\"^/([^/]+)/testboxes$\",\"paramNames\":[\"org\"],\"hasOptionalPrefix\":false},{\"path\":\"/:org/usage\",\"regex\":\"^/([^/]+)/usage$\",\"paramNames\":[\"org\"],\"hasOptionalPrefix\":false},{\"path\":\"/admin/internal-monitors/:org\",\"regex\":\"^/admin/internal-monitors/([^/]+)$\",\"paramNames\":[\"org\"],\"hasOptionalPrefix\":false},{\"path\":\"/admin/internal-monitors/:org/:ruleId\",\"regex\":\"^/admin/internal-monitors/([^/]+)/([^/]+)$\",\"paramNames\":[\"org\",\"ruleId\"],\"hasOptionalPrefix\":false},{\"path\":\"/settings/:section*?\",\"regex\":\"^/settings(?:/(.*))?$\",\"paramNames\":[\"section\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/admin\"},{\"path\":\"/admin/codesmith-leaderboard\"},{\"path\":\"/admin/internal-monitors\"},{\"path\":\"/analytics\"},{\"path\":\"/cache\"},{\"path\":\"/docker-analytics\"},{\"path\":\"/github-actions-analytics\"},{\"path\":\"/logs\"},{\"path\":\"/machine-definitions\"},{\"path\":\"/monitors\"},{\"path\":\"/network-monitoring\"},{\"path\":\"/rightsize\"},{\"path\":\"/runs\"},{\"path\":\"/stickydisks\"},{\"path\":\"/support\"},{\"path\":\"/testboxes\"},{\"path\":\"/usage\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.3.4";globalThis["_sentryRewritesTunnelPath"] = "/monitoring";import * as Sentry from "@sentry/nextjs";

import { isBotBrowser } from "@/lib/botBrowser";
import {
  hasBrowserExtensionFrame,
  isAnonymousInjectedError,
  isBrowserExtensionError,
} from "@/lib/browserExtensionErrors";
import { VERSION_REFRESH_ABORT_MESSAGE } from "@/hooks/useFrontendVersionRefresh";
import { onAppRouterTransitionStart } from "@/hooks/useDashboardRouter";

// parseFloat, not Number: an env var defined-but-empty must fall back to the
// default rather than coerce to 0 and silently switch tracing off.
const tracesSampleRateOverride = Number.parseFloat(
  process.env.NEXT_PUBLIC_SENTRY_TRACES_SAMPLE_RATE ?? "",
);

const profilesSampleRateOverride = Number.parseFloat(
  process.env.NEXT_PUBLIC_SENTRY_PROFILES_SAMPLE_RATE ?? "",
);

Sentry.init({
  dsn: "https://dd9f6cc17633dc550071fa506008026f@o4506462648401920.ingest.sentry.io/4506462745788416",

  tracesSampleRate: Number.isFinite(tracesSampleRateOverride)
    ? tracesSampleRateOverride
    : 0.1,

  // Relative to tracesSampleRate: 0.1 profiles a tenth of traced
  // transactions (~1% of pageloads). Profiles come from the JS
  // Self-Profiling API, so only Chromium browsers on pages served with
  // `Document-Policy: js-profiling` contribute.
  profilesSampleRate: Number.isFinite(profilesSampleRateOverride)
    ? profilesSampleRateOverride
    : 0.1,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,

  replaysOnErrorSampleRate: 1.0,

  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0.1,

  beforeSend(event) {
    if (isBotBrowser()) {
      return null;
    }

    if (isBrowserExtensionError(event)) {
      return null;
    }

    if (isAnonymousInjectedError(event)) {
      return null;
    }

    // Don't send errors for 401s since they're expected for session expiry
    if (
      event.exception?.values?.some(
        (value) => value?.value?.includes("status code 401"),
      )
    ) {
      return null;
    }

    // Filter pusher-js internal race condition errors (non-actionable library bug)
    if (
      event.exception?.values?.some(
        (value) =>
          value?.value?.includes(
            "Cannot read properties of undefined (reading 'sendMessage')",
          ),
      )
    ) {
      return null;
    }

    // Filter gtag ReferenceErrors caused by ad blockers blocking Google scripts
    if (
      event.exception?.values?.some(
        (value) => value?.value?.includes("gtag is not defined"),
      )
    ) {
      return null;
    }

    // Filter Next.js "Cancel rendering route" errors.
    // Next.js rejects the promise returned by router.push/replace when a
    // navigation is superseded by another in-flight navigation. This is
    // expected behavior (the user ends up at the newer destination) and
    // surfaces as an unhandled rejection captured by window.onunhandledrejection
    // in _app.tsx.
    if (
      event.exception?.values?.some(
        (value) => value?.value?.includes("Cancel rendering route"),
      )
    ) {
      return null;
    }

    // Filter the deliberate route-change abort useFrontendVersionRefresh
    // throws to turn an SPA transition into a full page load after a deploy.
    if (
      event.exception?.values?.some(
        (value) => value?.value?.includes(VERSION_REFRESH_ABORT_MESSAGE),
      )
    ) {
      return null;
    }

    // Filter "Failed to fetch" errors from third-party analytics scripts
    // (PostHog, gtag, GTM) caused by browser extensions / ad blockers, and
    // from extensions that wrap `window.fetch` and leak their own unhandled
    // rejection when a first-party request fails (e.g. Poper Blocker's
    // injectScriptAdjust.js).
    if (
      event.exception?.values?.some(
        (value) =>
          value?.value?.includes("Failed to fetch") &&
          (hasBrowserExtensionFrame(event) ||
            value?.stacktrace?.frames?.some(
              (frame) =>
                frame.filename?.includes("posthog") ||
                frame.filename?.includes("gtm.js") ||
                frame.filename?.includes("gtag/js"),
            )),
      )
    ) {
      return null;
    }

    // Filter browser extension errors that try to assign read-only Window properties
    // (e.g. Cardano wallet extensions injecting window.cardano)
    if (
      event.exception?.values?.some(
        (value) =>
          value?.value?.includes("Cannot assign to read only property") &&
          value?.value?.includes("of object '#<Window>'"),
      )
    ) {
      return null;
    }

    // Filter browser extension errors from injected scripts that call
    // Object.defineProperty with conflicting descriptor attributes
    // (e.g. password managers, crypto wallets, ad blockers injecting chunk-inject.js)
    if (
      event.exception?.values?.some(
        (value) =>
          value?.value?.includes("Invalid property descriptor") &&
          value?.value?.includes(
            "Cannot both specify accessors and a value or writable attribute",
          ) &&
          value?.stacktrace?.frames?.some(
            (frame) =>
              frame.filename?.includes("chunk-inject") ||
              frame.filename?.includes("inject.js") ||
              frame.filename?.includes("chrome-extension://") ||
              frame.filename?.includes("moz-extension://") ||
              frame.filename?.includes("safari-extension://"),
          ),
      )
    ) {
      return null;
    }

    // Don't send errors for 404s on job details endpoints since they're expected
    // when users click on jobs that are still in progress (job data not yet available)
    // The URL is stored in HTTP breadcrumbs, not in the exception message
    const isAxios404 = event.exception?.values?.some(
      (value) => value?.value?.includes("status code 404"),
    );

    if (isAxios404) {
      // Check HTTP breadcrumbs for 404 requests to job details endpoints
      const hasJobDetails404Breadcrumb = event.breadcrumbs?.some((crumb) => {
        const data = crumb?.data as Record<string, unknown> | undefined;
        if (!data) return false;
        const url = typeof data.url === "string" ? data.url : "";
        const status =
          typeof data.status_code === "number"
            ? data.status_code
            : typeof data.statusCode === "number"
            ? data.statusCode
            : null;
        return (
          status === 404 && url.includes("/metrics/actions/workflows/runs/")
        );
      });

      if (hasJobDetails404Breadcrumb) {
        return null;
      }
    }

    return event;
  },

  integrations: [
    Sentry.browserTracingIntegration({
      // ClickHouse-backed analytics sections routinely outlive the 15s child /
      // 30s total defaults, so the defaults would close the pageload
      // transaction before the slowest section (the one worth finding) resolves.
      childSpanTimeout: 30_000,
      finalTimeout: 45_000,
    }),
    Sentry.browserProfilingIntegration(),
    Sentry.replayIntegration({
      // Additional Replay configuration goes in here, for example:
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
});

export const onRouterTransitionStart: typeof onAppRouterTransitionStart = (
  url,
  navigationType,
) => {
  Sentry.captureRouterTransitionStart(url, navigationType);
  onAppRouterTransitionStart(url, navigationType);
};
